import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import LoadingSpinner from './LoadingSpinner';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  // Show loading indicator while auth is being determined
  if (loading) {
    return <LoadingSpinner />;
  }

  // If we're handling a redirect, don't navigate away yet
  if (localStorage.getItem('authRedirectState')) {
    return <LoadingSpinner />;
  }

  // Redirect to login if not authenticated
  if (!user) {
    // Save the attempted URL
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default PrivateRoute;
